import { render, staticRenderFns } from "./ConnectCustomer.vue?vue&type=template&id=bffcca1e&scoped=true"
import script from "./ConnectCustomer.vue?vue&type=script&lang=ts"
export * from "./ConnectCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffcca1e",
  null
  
)

export default component.exports